"use client";

import createIcon from './util/createIcon';
export default createIcon('M9,7V9H11V17H13V9H15V7H9Z', 'AlphaT');